(function () {
  var CONTROLS = 'input, select, textarea, button, [contenteditable]';
  function scroller(el, root) {
    for (var n = el; n && n !== root; n = n.parentElement) {
      var ox = getComputedStyle(n).overflowX;
      if ((ox === 'auto' || ox === 'scroll') && n.scrollWidth > n.clientWidth + 4) return n;
    }
    return null;
  }
  function visibleSlide(mains) {
    for (var i = 0; i < mains.children.length; i++) {
      if (getComputedStyle(mains.children[i]).display !== 'none') return mains.children[i];
    }
    return null;
  }
  function wire(root) {
    if (root.__dsSwipe) return;
    root.__dsSwipe = true;
    var g = null, swallow = false;
    root.addEventListener('pointerdown', function (e) {
      swallow = false;
      if (e.button !== 0 || !e.target.closest || e.target.closest(CONTROLS)) return;
      var gal = e.target.closest('.ds-gal__mains');
      var s = gal || e.pointerType !== 'mouse' ? null : scroller(e.target, root);
      if (!gal && !s) return;
      g = { gal: gal, s: s, id: e.pointerId, x: e.clientX, y: e.clientY, left: s ? s.scrollLeft : 0, moved: false };
      // A mouse press would otherwise start a text selection or a native image/link drag,
      // and either one cancels the pointer stream mid-gesture.
      if (e.pointerType === 'mouse') e.preventDefault();
    });
    root.addEventListener('pointermove', function (e) {
      if (!g || e.pointerId !== g.id) return;
      // The button came up outside the window, where no pointerup reached us.
      if (e.pointerType === 'mouse' && e.buttons === 0) return end(e);
      var dx = e.clientX - g.x;
      if (!g.moved && Math.abs(dx) > 6) {
        g.moved = true;
        // Captured only once it IS a drag: capture from the press would retarget the
        // click of a plain press, and a card link inside the row would stop working.
        var el = g.s || g.gal;
        try { el.setPointerCapture(e.pointerId); } catch (err) {}
        if (g.s) {
          g.snap = g.s.style.scrollSnapType;
          g.s.style.scrollSnapType = 'none';
        }
      }
      if (g.moved && g.s) g.s.scrollLeft = g.left - dx;
    });
    function end(e) {
      if (!g || e.pointerId !== g.id) return;
      var d = g;
      g = null;
      if (d.s && d.moved) d.s.style.scrollSnapType = d.snap || '';
      if (d.gal && e.type !== 'pointercancel') {
        var dx = e.clientX - d.x, dy = e.clientY - d.y;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          var slide = visibleSlide(d.gal);
          var arrow = slide && slide.querySelector(dx < 0 ? '.ds-gal__next' : '.ds-gal__prev');
          var input = arrow && (arrow.control || document.getElementById(arrow.htmlFor));
          if (input) input.checked = true;
          d.moved = true;
        }
      }
      swallow = d.moved;
      // The click a release produces is dispatched in the same task as the release; one
      // that never comes (released over another element) must not eat the next real one.
      if (swallow) setTimeout(function () { swallow = false; }, 0);
    }
    root.addEventListener('pointerup', end);
    root.addEventListener('pointercancel', end);
    root.addEventListener('click', function (e) {
      if (!swallow) return;
      swallow = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);
    root.addEventListener('dragstart', function (e) {
      if (g) e.preventDefault();
    });
  }
  function boot() {
    var roots = document.querySelectorAll('.ds-root');
    for (var i = 0; i < roots.length; i++) wire(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // The theme editor swaps a re-rendered section in without running its scripts; it
  // announces the new markup with this event instead.
  document.addEventListener('shopify:section:load', boot);
})();